import React from 'react'
import { useSelector } from 'react-redux';
import UserChip from '../../../../../../chip/UserChip';

const Students = () => {
  const studentsSelected = useSelector((state) => state?.classMarking?.studentsBulk || []);

  return (
    <div className='bg-background max-w-200px min-w-200px absolute  z-20'>
      <div className='overflow-auto' style={{ height: "calc(250px + 2rem)"}}>
        <div className=' flex flex-col gap-2 py-4 px-2'>
        {studentsSelected.map((student, index) => (
          <UserChip 
            key={index}
            name={student?.fullName}
            {...student}
          />
        ))}
      </div>
      </div>
    </div>
  )
}

export default Students